import { AfterViewInit, Component, EventEmitter, Input, Output, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import maplibregl from 'maplibre-gl';
import { environment } from '../../../enviroment/enviroment';

@Component({
  selector: 'app-mapa-direccion',
  standalone: true,
  imports: [],
  templateUrl: './map.component.html',
  styleUrl: './map.component.css'
})
export class MapaDireccionComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input() initialLat: number = 4.7110; // Bogotá por defecto
  @Input() initialLng: number = -74.0721;
  @Input() zoom: number = 14;
  @Output() coordenadas = new EventEmitter<{ lat: number, lng: number }>();

  private region = environment.amazonLocation.region;
  private mapName = environment.amazonLocation.mapName;
  private accessToken = environment.amazonLocation.accessToken;
  private map!: maplibregl.Map;

  ngAfterViewInit(): void {

    setTimeout(() => {
      this.initializeMap();
    }, 100);
  }

  private initializeMap(): void {
    try {
      // Verificar que el contenedor existe
      const mapContainer = document.getElementById('map');
      if (!mapContainer) {
        console.error('❌ Contenedor del mapa no encontrado');
        return;
      }

      this.map = new maplibregl.Map({
        container: 'map',
        style: `https://maps.geo.${this.region}.amazonaws.com/maps/v0/maps/${this.mapName}/style-descriptor?key=${this.accessToken}`,
        center: [this.initialLng, this.initialLat], // [lng, lat] - correcto para MapLibre
        zoom: this.zoom,
      });

      // Espera a que el mapa se cargue completamente
      this.map.on('load', () => {
        console.log('✅ Mapa completamente cargado');
        
        // Evento de click en el mapa
        this.map.on('click', (e) => {
          const lng = e.lngLat.lng;
          const lat = e.lngLat.lat;

          this.coordenadas.emit({ lat, lng });
        });
      });

      // Manejar errores del mapa
      this.map.on('error', (e) => {
        console.error('❌ Error del mapa:', e);
      });
      
    } catch (error) {
      console.error('❌ Error al crear el mapa:', error);
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    // Detectar cambios en las coordenadas iniciales
    if ((changes['initialLat'] || changes['initialLng']) && this.map) {
      console.log('🔄 Detectados cambios en coordenadas:', {
        lat: this.initialLat,
        lng: this.initialLng
      });
      
      // Actualizar posición del mapa y marcador
      this.updatePosition(this.initialLat, this.initialLng);
      
      // Emitir las nuevas coordenadas
      this.coordenadas.emit({ lat: this.initialLat, lng: this.initialLng });
    }
  }

  ngOnDestroy(): void {
    if (this.map) {
      this.map.remove();
    }
  }

  // Método para actualizar la posición desde el exterior
  updatePosition(lat: number, lng: number): void {
    if (this.map) {
      console.log('📍 Actualizando posición del mapa a:', { lat, lng });
            
      // Centrar mapa en las nuevas coordenadas con animación suave
      this.map.flyTo({
        center: [lng, lat], // [lng, lat] - orden correcto para MapLibre
        zoom: this.zoom,
        duration: 1000 // 1 segundo de animación
      });

      console.log('✅ Posición actualizada en el mapa');
    } else {
      console.warn('⚠️ Mapa no está inicializado aún');
    }
  }
}